import React from 'react';
import clsx from 'clsx';
import './Link.scss';

export interface LinkProps {
  href: string;
  target?: string;
  rel?: string;
  children: React.ReactNode;
  textDecoration?: 'none' | 'underline';
  className?: string;
}

export const Link: React.FC<LinkProps> = ({
  href,
  target = '_blank',
  rel = 'noopener noreferrer',
  textDecoration,
  className = '',
  children,
}) => {
  // Treat empty string, null or undefined as 'underline' by default
  const decoration = textDecoration || 'underline';

  const classes = clsx('link', `text-decoration-${decoration}`, className);

  return (
    <a href={href} target={target} rel={rel} className={classes}>
      {children}
    </a>
  );
};

export const externalRedirect = (href: string, target = '_blank', rel = 'noopener noreferrer') => {
  window.open(href, target, rel);
};

export default Link;
